import { render, staticRenderFns } from "./BottomSheetEvent.vue?vue&type=template&id=23e1b870"
import script from "./BottomSheetEvent.vue?vue&type=script&lang=js"
export * from "./BottomSheetEvent.vue?vue&type=script&lang=js"
import style0 from "./BottomSheetEvent.vue?vue&type=style&index=0&id=23e1b870&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports